export default __webpack_public_path__ + "static/media/star.f139a2fe.webp";